$(document).ready(function () {

  // Footer Ajax contact form
   $(".js-footer-newsletter form .newsl_btn").click(function(ev) {
     ev.preventDefault();
      var form = $(this).closest("#footer");
      var url = form.attr('action');
      $.ajax({
          type: "POST",
          url: url,
          data: form.serialize(),
          success: function(data) {
            $(form).find('.form--success').addClass('active');
            $(form).find('.nwfrm').hide();
          },
          error: function(data) {
            alert("some Error");
          }
      });
  });

  // Product -> Delivery button modal
  $(".js-delivery-popup").click(function (e) {
    e.preventDefault();
    $.ajax({
       url:'/pages/delivery-returns-new',
       type:'GET',
       success: function(data){
          $('.product-delivery-modal .content-part').html($(data).find('.delivery-table-part').html());
          $('.product-delivery-modal').addClass('is-active');
          if(!$('body').hasClass("isdeliverypopup")){
            $('body').toggleClass("isdeliverypopup");
          }
       }
    });
  });
  $('.close-deliverypopup').click(function(e){
    $('body').toggleClass("isdeliverypopup");
  });
  $('body').click(function(e){
    if( $(e.target).is('.isdeliverypopup') ) {
      e.preventDefault();
      $(this).removeClass('isdeliverypopup');
    }
  });
  
});